import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import { useCombinedStore } from "../store";

const PrivateRoutes: React.FC = () => {
  const authUserZustand = useCombinedStore((state) => state.authUserZustand);
  const token = authUserZustand?.Token;
  const isAuthenticated = !!token;

  if (isAuthenticated) {
    return (
      <MainLayout>
        <Outlet />
      </MainLayout>
    );
  } else {
    return <Navigate to="/login" />;
  }
};

export default PrivateRoutes;
